
<template>
  <div class="chat-container">
    <!-- 消息列表 -->
    <div ref="messagesContainer" class="messages-container">
      <div
        v-for="(message, index) in messages"
        :key="index"
        class="message-wrapper"
        :class="[message.role]"
      >
<!--        <div class="avatar">-->
<!--          <img-->
<!--            v-if="message.role === 'user'"-->
<!--            src="@/assets/img/defaultHeader.png"-->
<!--            alt="User"-->
<!--          >-->
<!--          <img-->
<!--            v-else-->
<!--            src="@/assets/img/icon_jiankangSearch@2x.png"-->
<!--            alt="AI"-->
<!--          >-->
<!--        </div>-->
<!--        <div class="message-bubble">-->
<!--          <div v-if="message.role === 'assistant'" class="think">思考：</div>-->
<!--          <div class="content">-->
<!--            {{ message.reasoning_content }}-->
<!--          </div>-->
<!--          <div v-if="message.role === 'assistant'" class="think">结果：</div>-->
<!--          <div class="content">-->
<!--            {{ message.content }}-->
<!--          </div>-->
<!--          <div v-if="message.loading" class="loading-indicator">-->
<!--            <div class="dot-flashing"></div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="bot-message" v-if="message.role === 'assistant'">
          <div class="message-bubble">
            <div class="think" v-if="index > 0">思考：</div>
            <div class="content thinkContent"  v-if="index > 0" v-html="message.reasoning_content">
<!--              {{ message.reasoning_content }}-->
            </div>
            <div class="think" v-if="index > 0">结果：</div>
            <div class="content" v-html="message.content">
<!--              {{ message.content }}-->
            </div>
          </div>
        </div>
        <div v-else class="message user-message">
          <div class="message-bubble">{{ message.content }}</div>
        </div>

      </div>
    </div>

    <!-- 输入区域 -->
    <div class="input-container">
      <div class="input-wrapper">
        <input
          ref="inputArea"
          v-model="inputText"
          placeholder="输入你的问题..."
          id="userInput" class="inputText"
          @keydown.enter.exact.prevent="handleSend"
        >
        <!--        :disabled="!inputText.trim() || isSending"-->
        <button
          id="sendBtn"
          class="send-button"
          @click="handleSend"
        >
          发送
<!--          <svg class="send-icon" viewBox="0 0 24 24">-->
<!--            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>-->
<!--          </svg>-->
        </button>
      </div>

<!--      <div class="input-area">-->
<!--        <input type="text" id="userInput" class="inputText" placeholder="输入您的问题..." autofocus>-->
<!--        <button id="sendBtn" @click="handleSend">发送</button>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'AIUrl',
  components: {

  },
  data () {
    return {
      isLoading: false,
      isSending: false,
      messages: [
        {
          role: 'assistant',
          content: "您好！我是 小康知道 智能助手，有什么可以帮您？"
        }
      ],
      inputText: '',
      error: ''
    }
  },
  beforeCreate () {

  },
  created () {

  },
  mounted () {
    this.scrollToBottom();
  },
  methods: {
    scrollToBottom () {
      this.$nextTick(() => {
        var el = this.$refs.messagesContainer;
        el.scrollTop = el.scrollHeight;
      })
    },
    async handleSend () {
      if (!this.inputText.trim() || this.isSending) return
      const userMessage = {
        role: 'user',
        content: this.inputText.trim()
      }

      this.messages.push(userMessage);
      this.inputText = '';
      this.scrollToBottom();
      try{
        // 发送请求
        var key = "sk-1b456f34f9b445dabab3edaaa1230e73";
        var param = {
          "model": "deepseek-r1",
          "messages": this.messages,
          "stream": true,
          "stream_options": {
            "include_usage": true
          }
        }
        let response = await fetch("https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions",
          {
            method: "post",
            responseType: "stream",
            headers: {
              Authorization: `Bearer ${key}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(param)
          }
        );
        // ok字段判断是否成功获取到数据流
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        // 用来获取一个可读的流的读取器（Reader）以流的方式处理响应体数据
        const reader = response.body.getReader();
        // 将流中的字节数据解码为文本字符串
        const decoder = new TextDecoder();
        let result = true;
        let sqlValue = '';
        var assistantMessage = {
          role: 'assistant',
          content: "",
          reasoning_content: "",
        }
        this.messages.push(assistantMessage);
        while (result) {
          // done表示流是否已经完成读取  value包含读取到的数据块
          const { done, value } = await reader.read();
          if (done) {
            result = false;
            console.log("assistantMessage");
            console.log(assistantMessage);
            break;
          }
          const chunk = decoder.decode(value)
          const lines = chunk.split('\n').filter(line => line.trim())
          // console.log("lines");
          // console.log(lines);
          for (const line of lines) {
            const message = line.replace(/^data: /, '')
            if (message === '[DONE]') break
            try {
              const parsed = JSON.parse(message);
              // console.log("parsed");
              // console.log(parsed);
              if(parsed.choices[0].delta.content){
                console.log("delta.content");
                console.log(parsed.choices[0].delta.content);
                assistantMessage.content += parsed.choices[0].delta.content;
                assistantMessage.content = assistantMessage.content.replace(/\#\#\# \*\*(.*?)\*\*/g, (match, p1) =>
                  `<div class="textTitle">${p1}</div>`
                )
                assistantMessage.content = assistantMessage.content.replace(/\#\#\#\# \*\*(.*?)\*\*/g, (match, p1) =>
                  `<div class="textTitle1">${p1}</div>`
                )
                assistantMessage.content = assistantMessage.content.replace(/\`\`\`(.*?)\`\`\`/g, (match, p1) =>
                  `<div class="bgBlack">${p1}</div>`
                )
                assistantMessage.content = assistantMessage.content.replace(/\`(.*?)\`/g, (match, p1) =>
                  `<span class="bgGray">${p1}</span>`
                )
                assistantMessage.content = assistantMessage.content.replace(/\*\*(.*?)\*\*/g, (match, p1) =>
                  `<span class="textStrong">${p1}</span>`
                )
                assistantMessage.content = assistantMessage.content.replace(/\-\-\-/g, `<br /><br />`);
              }
              if(parsed.choices[0].delta.reasoning_content){
                assistantMessage.reasoning_content += parsed.choices[0].delta.reasoning_content
              }
              this.$nextTick(() => {
                this.scrollToBottom();
              })
              // if (parsed.choices?.[0]?.delta?.content) {
              //   assistantMessage.content += parsed.choices[0].delta.content
              // }
              // if (parsed.usage) {
              //   console.log('Token用量:', parsed.usage)
              // }
            } catch (e) {
              console.warn('解析JSON失败:', e)
            }
          }
          // 拿到的value就是后端分段返回的数据，大多是以data:开头的字符串
          // 需要通过decode方法处理数据块，例如转换为文本或进行其他操作
          // const chunkText = textDecoder
          //   .decode(value)
          //   .split("\n")
          //   .forEach((val) => {
          //     if (!val) return;
          //     try {
          //       // 后端返回的流式数据一般都是以data:开头的字符，排除掉data:后就是需要的数据
          //       // 具体返回结构可以跟后端约定
          //       let text = val?.replace("data:", "") || ""
          //       console.log(val, text, "输出分段返回的数据");
          //       sqlValue += text;
          //     } catch (err) {}
          //   });
        }
      }catch(err) {}




      return;
      var param = {
        "model": "deepseek-r1",
        "messages": this.messages,
        "stream": true,
        "stream_options": {
          "include_usage": true
        }
      }
      this.$api.getAIResult(param).then((res) => {
        if (res && res.data) {
          var reponse = res.data;
          let assistantMessage = {
            role: 'assistant',
            content: reponse.choices[0].message.content,
            reasoning_content: reponse.choices[0].message.reasoning_content,
          }
          this.messages.push(assistantMessage);
          this.$nextTick(() => {
            this.scrollToBottom();
          })
        }
      });
    }
  }
}
</script>

<!--<script>-->
<!--import { ref, reactive, watch, nextTick } from 'vue'-->

<!--const API_CONFIG = {-->
<!--  endpoint: 'https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions',-->
<!--  apiKey: "sk-1b456f34f9b445dabab3edaaa1230e73",-->
<!--  model: 'deepseek-r1'-->
<!--}-->

<!--const messages = reactive([-->
<!--  {-->
<!--    role: 'assistant',-->
<!--    content: '您好！我是DeepSeek-R1智能助手，有什么可以帮您？',-->
<!--    isStreaming: false-->
<!--  }-->
<!--])-->

<!--const inputText = ref('')-->
<!--const isLoading = ref(false)-->
<!--const error = ref(null)-->
<!--const historyContainer = ref(null)-->

<!--// 流式响应处理-->
<!--const processStream = async (response) => {-->
<!--  try {-->
<!--    const reader = response.body.getReader()-->
<!--    const decoder = new TextDecoder()-->
<!--    let assistantMessage = {-->
<!--      role: 'assistant',-->
<!--      content: '',-->
<!--      isStreaming: true-->
<!--    }-->

<!--    messages.push(assistantMessage)-->

<!--    while (true) {-->
<!--      const { done, value } = await reader.read()-->
<!--      if (done) break-->

<!--      const chunk = decoder.decode(value)-->
<!--      const lines = chunk.split('\n').filter(line => line.trim())-->

<!--      for (const line of lines) {-->
<!--        const message = line.replace(/^data: /, '')-->
<!--        if (message === '[DONE]') break-->

<!--        try {-->
<!--          const parsed = JSON.parse(message)-->
<!--          if (parsed.choices?.[0]?.delta?.content) {-->
<!--            assistantMessage.content += parsed.choices[0].delta.content-->
<!--          }-->
<!--          if (parsed.usage) {-->
<!--            console.log('Token用量:', parsed.usage)-->
<!--          }-->
<!--        } catch (e) {-->
<!--          console.warn('解析JSON失败:', e)-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  } catch (err) {-->
<!--    error.value = `流式请求失败: ${err.message}`-->
<!--  } finally {-->
<!--    assistantMessage.isStreaming = false-->
<!--    isLoading.value = false-->
<!--  }-->
<!--}-->

<!--const callDeepSeekAPI = async (prompt) => {-->
<!--  isLoading.value = true-->
<!--  error.value = null-->

<!--  try {-->
<!--    messages.push({-->
<!--      role: 'user',-->
<!--      content: prompt-->
<!--    })-->

<!--    const response = await fetch(API_CONFIG.endpoint, {-->
<!--      method: 'POST',-->
<!--      headers: {-->
<!--        'Authorization': `Bearer ${API_CONFIG.apiKey}`,-->
<!--        'Content-Type': 'application/json'-->
<!--      },-->
<!--      body: JSON.stringify({-->
<!--        model: API_CONFIG.model,-->
<!--        messages: [-->
<!--          ...messages.filter(m => m.role !== 'assistant' || !m.isStreaming),-->
<!--          { role: 'user', content: prompt }-->
<!--        ],-->
<!--        stream: true,-->
<!--        stream_options: {-->
<!--          include_usage: true-->
<!--        }-->
<!--      })-->
<!--    })-->

<!--    if (!response.ok) {-->
<!--      throw new Error(`HTTP错误 ${response.status}`)-->
<!--    }-->

<!--    await processStream(response)-->
<!--    inputText.value = ''-->
<!--  } catch (err) {-->
<!--    error.value = `请求失败: ${err.message}`-->
<!--    messages.pop() // 移除未完成的assistant消息-->
<!--  }-->
<!--}-->

<!--const handleSend = async () => {-->
<!--  const prompt = inputText.value.trim()-->
<!--  if (!prompt) return-->

<!--  await callDeepSeekAPI(prompt)-->
<!--}-->

<!--// 自动滚动到底部-->
<!--watch(messages, async () => {-->
<!--  await nextTick()-->
<!--  historyContainer.value?.scrollTo({-->
<!--    top: historyContainer.value.scrollHeight,-->
<!--    behavior: 'smooth'-->
<!--  })-->
<!--})-->
<!--</script>-->
<style>
.bgGray{
  background: #F1F1F1;
}
.bgBlack{
  background: #2B2B2B;
}
.textTitle{
  font-size: 0.4333rem;
  margin-bottom: 0.2rem;
}
.textTitle1{
  font-size: 0.38rem;
}
.textStrong{

}
</style>
<style scoped>

.thinkContent{
  color: #aaa;
}
.bot-message{
  margin-bottom: 0.2rem;
}
.bot-message .message-bubble{
  background: white;
  border: 1px solid #eee;
  border-radius: 0.083333rem 0.6rem 0.6rem 0.6rem;;
}
.user-message .message-bubble{
  background: #3498db;
  color: white;
  border-radius: 0.24rem 0.24rem 0.053333rem 0.24rem;
  font-size: 0.43rem;
}
.message{
  margin-bottom: 15px;
  display: flex;
  gap: 12px;
}
.user-message{
  justify-content: flex-end;
  width: 100%;
}
.input-area {
  display: flex;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #eee;
}
.message-bubble{
  max-width: 95%;
  padding: 0.2rem 0.24rem;
  border-radius: 18px;
  line-height: 1.3;
}
#userInput {
  flex: 1;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 0.43rem;
}

#sendBtn {
  padding: 0.23rem;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 0.43rem;
}

#sendBtn:hover {
  background: #2980b9;
}
.content{
  font-size: 0.4333rem;
  line-height: 1.3;
  margin-bottom: 0.2rem;
}
.think{
  font-weight: bolder;
  margin-bottom: 0.2rem;
  font-size: 0.48rem;
}
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f8f9fa;
}

.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 0;
}

.message-wrapper {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.message-wrapper.user {
  flex-direction: row-reverse;
}

.avatar {
  width: 0.633333rem;
  height: 0.633333rem;
  border-radius: 50%;
  overflow: hidden;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.loading-indicator {
  margin-top: 8px;
}

.dot-flashing {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #ccc;
  animation: dot-flashing 1s infinite linear;
}

@keyframes dot-flashing {
  0% { opacity: 0.2 }
  50% { opacity: 1 }
  100% { opacity: 0.2 }
}

.input-container {
  padding: 20px;
  background: white;
  border-top: 1px solid #eee;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  max-width: 800px;
  margin: 0 auto;
}

textarea {
  flex: 1;
  min-height: 40px;
  max-height: 200px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: none;
  font-family: inherit;
  font-size: 0.413333rem;
}

.send-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.send-icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
}
</style>
